export default "__VITE_ASSET__CEfcxgFk__"